<div *ngIf="editMode" class="overlay bg-black opacity-30 fixed top-0 left-0 w-screen h-screen z-30"></div>

<div class="flex flex-row justify-between mt-4 min-h-[40px]">
	<p class="text-[#1C252E] font-medium text-base leading-5 m-0">
		{{ 'ORGANIZATION.BRANCH.SOCIAL_ACCOUNTS' | translate }}
	</p>
	<div
		*ngIf="!editMode"
		class="flex gap-1 ltr:mr-6 rtl:ml-6 hover:cursor-pointer"
		(click)="changeEditMode()"
	>
		<img class="w-5 max-h-5" src="assets/images/edit-blue.svg" alt="" />
		<p class="text-[#009EF7]">{{ 'ACTIONS.EDIT' | translate }}</p>
	</div>
</div>
<div
	class="flex flex-col custom-shadow p-24px gap-[14px] rounded-12px bg-off-white lg:w-[776px]  {{editMode ? 'z-40' : ''}} relative"
>
	<form [formGroup]="socialAccForm">
		<mat-form-field class="w-full relative mb-[12px]" appearance="outline">
			<img
				class="w-[24px] h-[24px] absolute top-5 ltr:left-4 rtl:right-4"
				src="assets/images/instagram-svgrepo-com.svg"
				alt=""
			/>

			<input
				type="text"
				class="mx-10 max-w-[600px] mb-2 smMobile:text-font-14 text-[12px]"
				matInput
				maxlength="250"
				formControlName="instagramLink"
				[value]="this.branchInformationData?.instagramLink"
				placeholder="{{ 'GENERAL_LABELS.INSTAGRAM' | translate }}"
			/>
			<img
				*ngIf="editMode && getController('instagramLink')?.value"
				class="cursor-pointer absolute  ltr:right-3 rtl:left-3 top-[15px] inline-block"
				src="./assets/images/close-square.svg"
				alt=""
				(click)="getController('instagramLink').reset()"
			/>
			<mat-error>
				<validation-message
					[controller]="getController('instagramLink')"
					controller_name="GENERAL_LABELS.INSTAGRAM"
					pattern_Message="VALIDATION.ACC"
				>
				</validation-message>
			</mat-error>
		</mat-form-field>
		<mat-form-field class="w-full relative" appearance="outline">
			<img
				class="w-[24px] h-[24px] absolute top-5 ltr:left-4 rtl:right-4"
				src="assets/images/FacebookLogo.svg"
				alt=""
			/>

			<input
				type="text "
				placeholder="{{ 'GENERAL_LABELS.FACEBOOK' | translate }}"
				class="mx-10 text-dark-grey max-w-[600px] mb-2 smMobile:text-font-14 text-[12px]"
				matInput
				maxlength="250"
				formControlName="facebookLink"
				[value]="this.branchInformationData?.facebookLink"
			/>
			<img
				*ngIf="editMode && getController('facebookLink')?.value"
				class="cursor-pointer absolute  ltr:right-3 rtl:left-3 top-[15px] inline-block"
				src="./assets/images/close-square.svg"
				alt=""
				(click)="getController('facebookLink').reset()"
			/>
			<mat-error>
				<validation-message
					[controller]="getController('facebookLink')"
					controller_name="GENERAL_LABELS.FACEBOOK"
					pattern_Message="VALIDATION.ACC"
				>
				</validation-message>
			</mat-error>
		</mat-form-field>
		<!-- <mat-form-field class="w-full relative" appearance="outline">
			<img
				class="w-[24px] h-[24px] absolute top-2"
				src="assets/images/twitter.svg"
				alt=""
			/>

			<input
				type="text"
				class="mx-10 mb-2"
				matInput
				placeholder="{{ 'GENERAL_LABELS.@TWIT' | translate }}"
			/>
		</mat-form-field> -->

		<div *ngIf="editMode" class="flex justify-between">
			<div></div>
			<div class="flex mt-24px">
				<button
					(click)="changeEditMode(); initForm()"
					class="border border-solid border-[#D9DBE9] text-dark-grey hover:bg-gradient hover:text-off-white mx-2"
					mat-button
				>
					{{ 'ACTIONS.CANCEL' | translate }}
				</button>
				<button
					(click)="update()"
					class="bg-gradient text-off-white rounded"
					mat-button
					[disabled]="socialAccForm.invalid || !isChanged"
				>
					{{ 'ACTIONS.SAVE' | translate }}
				</button>
			</div>
		</div>
	</form>
</div>
